export class RadioOptionBuilder {
    constructor() {
        this.options = [];
    }

    add(value, label, options = {}) {
        const opt = { value, label: label || value, ...options };
        this.options.push(opt);
        return this._wrapOption(opt);
    }

    _wrapOption(opt) {
        const self = this;
        return {
            withColor: (c) => { opt.color = c; return self._wrapOption(opt); },
            withLabelColor: (c) => { opt.labelColor = c; return self._wrapOption(opt); },
            add: (v, l, o) => self.add(v, l, o)
        };
    }

    build() {
        return this.options;
    }
}
